import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'

interface LiveClockProps {
    timeZone: string
    seconds?: boolean
    className?: string
}

/** Local time in a store city. Rendered after mount so server and browser markup always match. */
const LiveClock: FC<LiveClockProps> = ({ timeZone, seconds = true, className }): ReactNode => {
    const [time, setTime] = useState<string | null>(null)

    useEffect(() => {
        const format = new Intl.DateTimeFormat('en-GB', {
            timeZone,
            hour: '2-digit',
            minute: '2-digit',
            second: seconds ? '2-digit' : undefined,
            hourCycle: 'h23'
        })

        const tick = (): void => setTime(format.format(new Date()))

        tick()

        const interval = window.setInterval(tick, 1000)

        return () => window.clearInterval(interval)
    }, [timeZone, seconds])

    return (
        <span className={className ? `${className} tabular-nums` : 'tabular-nums'}>
            {time ?? (seconds ? '--:--:--' : '--:--')}
        </span>
    )
}

export default LiveClock
